/*
Newsletter form
*/

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

const NewsletterForm = () => {
  const [newsletterFormState, setNewsletterFormState] = useState({
    email: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (name, value) => {
    setNewsletterFormState({
      ...newsletterFormState,
      [name]: value,
    });
  };

  const handleConfirmSend = async () => {
    setLoading(true);
    const response = await fetch(
      "https://www.gaia-travels.com/ajax/pages/subscribe/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...newsletterFormState }),
      }
    );
    const json = await response.json();
    if (json.ok) {
      setNewsletterFormState({
        email: "",
      });

      setSubmitted("ok");
    } else {
      setSubmitted(json.errors);
    }

    setLoading(false);
  };

  let isFormEmpty = newsletterFormState.email === "";

  let confirmMessage = null;

  if (submitted === "ok") {
    confirmMessage = <span className="small">Kiitos tilauksesta!</span>;
  } else if (submitted) {
    confirmMessage = <span className="small text-primary">{submitted}</span>;
  }

  let buttonIcon = (
    <FontAwesomeIcon
      icon={faPaperPlane}
      className="icon-muted"
      fixedWidth
      size="lg"
    />
  );
  if (loading) {
    buttonIcon = (
      <FontAwesomeIcon
        icon={faPaperPlane}
        pulse
        className="icon-muted turn-icon"
        fixedWidth
        size="lg"
      />
    );
  }
  return (
    <form action="#" id="newsletter-form">
      <div style={{ display: "block", minHeight: "25px" }}>
        {confirmMessage}
      </div>
      <div className="input-group mb-3">
        <input
          type="email"
          name="email"
          placeholder="Lähettäjän Email"
          className="form-control bg-transparent border-dark border-right-0"
          value={newsletterFormState.email}
          onKeyPress={e => {
            if (e.key === "Enter") {
              handleInputChange(newsletterFormState);
            }
          }}
          onChange={e => {
            handleInputChange(e.target.name, e.target.value);
          }}
        />
        <div className="input-group-append">
          <button
            type="submit"
            className="btn btn-outline-dark border-left-0"
            disabled={isFormEmpty}
            onClick={e => {
              e.preventDefault();
              handleConfirmSend();
            }}
          >
            {buttonIcon}
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewsletterForm;
